import React, { useState } from 'react';

import { useLoadScript, Autocomplete } from '@react-google-maps/api';
import FormInputStyle from '../FormInput/style';

const scriptOptions = {
	googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_PLACES_API,
	libraries: ['places'],
};

const FormAddress = ({ toggleAutoFill, setFields, placeholder, onChange, setValue }) => {
	const { isLoaded } = useLoadScript(scriptOptions);
	const [autocomplete, setAutocomplete] = useState(null);

	const onLoad = (autocompleteObj) => {
		setAutocomplete(autocompleteObj);
	};

	const getDataByType = (components, type, nameType = 'short_name') =>
		components?.find((comp) => comp.types.includes(type))?.[nameType];

	const onPlaceChanged = () => {
		const place = autocomplete?.getPlace?.();
		const address_components = place?.address_components;

		if (!address_components?.length) return;

		const unitNo = getDataByType(address_components, 'subpremise') ?? '';
		const streetNumber = getDataByType(address_components, 'street_number');
		const route = getDataByType(address_components, 'route', 'long_name');
		// AU suburbs vary: locality, subpremise-area suburbs, or LGA-level labels
		const locality =
			getDataByType(address_components, 'locality') ||
			getDataByType(address_components, 'sublocality') ||
			getDataByType(address_components, 'sublocality_level_1') ||
			getDataByType(address_components, 'neighborhood') ||
			getDataByType(address_components, 'administrative_area_level_2', 'long_name');

		let state = getDataByType(address_components, 'administrative_area_level_1', 'short_name');
		if (state) state = String(state).trim().toUpperCase();

		const postalCode = getDataByType(address_components, 'postal_code');

		const streetAddress = `${streetNumber ? `${streetNumber} ` : ''}${route || ''}`.trim();

		if (typeof setFields === 'function') {
			setFields([
				{ name: 'address', value: place.formatted_address || '' },
				{ name: 'apartment', value: unitNo || '' },
				{ name: 'street_address', value: streetAddress },
				{ name: 'suburb', value: locality || '' },
				{ name: 'state', value: state || '' },
				{ name: 'postcode', value: postalCode || '' },
			]);
		}

		if (typeof setValue === 'function') {
			setValue('address', place.formatted_address || '');
			setValue('apartment', unitNo || '');
			setValue('street_address', streetAddress);
			setValue('suburb', locality || '');
			setValue('state', state || '');
			setValue('postcode', postalCode || '');
		}

		const incomplete =
			!streetAddress ||
			!route ||
			!locality ||
			!state ||
			!postalCode ||
			!place?.formatted_address;

		if (incomplete && typeof toggleAutoFill === 'function') {
			toggleAutoFill();
		}
	};

	return (
		<FormInputStyle>
			{isLoaded ? (
				<Autocomplete
					onLoad={onLoad}
					onPlaceChanged={onPlaceChanged}
					options={{
						componentRestrictions: { country: 'au' },
					}}
					fields={['formatted_address', 'address_components']}>
					<input
						type='text'
						placeholder={placeholder}
						onChange={(e) => {
							if (typeof onChange === 'function') {
								onChange(e.target.value);
							}
						}}
					/>
				</Autocomplete>
			) : null}
		</FormInputStyle>
	);
};

export default FormAddress;
